<template>
  <div id="sl-main-list">
    <template v-if="listIsReady">
      <div class="list-filters" v-if="this.neededItems.length">
        <div class="filter stores">
          <div class="filter-title">Show Store:</div>
          <div class="filter-items">
            <span class="label sl-store-label c-hand" @click="filterByStore(null)" :class="{'active': !filterStoreId}">All</span>
            <span class="label sl-store-label c-hand" v-for="store in neededItemsStores" :key="store.id"
                  @click="filterByStore(store.id)"
                  :class="{'active': filterStoreId === store.id}">{{ store.name }}</span>
          </div>
        </div>
      </div>
      <list-section label="Needed" icon="clipboard-list" :section-items="itemsStillNeeded" @item-status-changed="putInBasket"/>
      <list-section label="In Basket" icon="shopping-basket" :is-basket="true" :section-items="itemsInCart" :is-busy="basketIsBusy" @item-status-changed="takeOutOfBasket"/>
      <section v-if="itemsInCart.length" class="sl-list-section sl-list-controls">
        <button @click="checkOut" class="btn btn-secondary"><fa-icon icon="cash-register" size="lg"></fa-icon><span>Check Out</span></button>
      </section>
    </template>
    <template v-else>
      <div class="loading loading-xl"></div>
    </template>
  </div>
</template>

<script>
/*
  TODO:
    - Filter out eventual items
*/
import _ from 'lodash'
import Pull from 'pulljs'

export default {
  name: 'list',
  data () {
    return {
      basketIsBusy: false,
      filterStoreId: null
    }
  },
  computed: {
    itemsStillNeeded () {
      return _.chain(this.neededItems)
        .filter(i => {
          return !i.isInCart && (!this.filterStoreId || _.includes(i.storeIds, this.filterStoreId))
        })
        .sortBy(i => i.name.toLowerCase())
        .value()
    },
    itemsInCart () {
      return _.chain(this.neededItems).filter(i => i.isInCart).sortBy(i => i.name.toLowerCase()).value()
    },
    listIsReady () {
      return this.storesAreLoaded && this.categoriesAreLoaded && this.neededItemsAreLoaded
    }
  },
  methods: {
    async refresh () {
      // FUTURE: only refresh needed items...
      await this.refreshItems()
    },
    filterByStore (storeId) {
      if (storeId !== this.filterStoreId) {
        this.filterStoreId = storeId
      }
    },
    putInBasket (item) {
      this.setItemCartStatus({ id: item.id, isInCart: true })
    },
    takeOutOfBasket (item) {
      this.setItemCartStatus({ id: item.id, isInCart: false })
    },
    async checkOut () {
      this.basketIsBusy = true
      await this.purchaseItemsInCart()
      this.basketIsBusy = false
    }
  },
  created () {
    this.verifySignedIn()

    // Setup pull to refresh
    Pull.init({
      ptrOnDesktop: true,
      instructionsPullToRefresh: '&DownTeeArrow;',
      instructionsReleaseToRefresh: '&check;',
      instructionsRefreshing: '&hellip;',
      onRefresh: this.refresh
    })
  },
  watch: {
    neededItemsStores () {
      if (!_.includes(_.map(this.neededItemsStores, s => s.id), this.filterStoreId)) {
        this.filterStoreId = null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(self => {
      self.setPageMeta(to.meta)
    })
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  .sl-list-controls {
    display: flex;
    .btn {
      flex: 1 0 auto;
    }
  }

  .list-filters {
    padding: 0.5rem;
    background-color: $darkest-color;
    margin-bottom: 0.5rem;
    border-radius: 0.5rem;

    .filter {
      display: flex;
      flex-direction: row;

      .filter-title {
        flex: 1 0 min-content;
        color: darken($light-color, 20%);
        font-size: 0.6rem;
        text-transform: uppercase;
        font-weight: bold;
        margin-right: 0.5rem;
      }

      .filter-items {
        flex: 1 0 min-content;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: flex-start;
        margin-top: -0.25rem;

        .label {
          white-space: nowrap;
          flex: 0 0 min-content;
          margin: 0.25rem 0.25rem 0 0;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
    }

    .stores {
      align-items: center;
      .sl-store-label {
        &.active {
          background-color: $link-color;
          box-shadow: 0 1px 2px rgba(0,0,0,0.5);
        }
      }
    }
  }
</style>
